import i18n from 'i18next'

const SkipLogicOperators = [
    {
        value: 'AND',
        label: 'AND',
    },
    {
        value: 'OR',
        label: 'OR',
    },
]

const getQuotaOptions = () => [
    {
        value: 'Lt',
        label: i18n.t('quota.lt', 'Less than today'),
    },
    {
        value: 'Lte',
        label: i18n.t('quota.lte', 'Less than or equal to today'),
    },
    {
        value: 'Eq',
        label: i18n.t('quota.eq', 'Equal to today'),
    },
    {
        value: 'Gte',
        label: i18n.t('quota.gte', 'Greater than or equal to today'),
    },
    {
        value: 'Gt',
        label: i18n.t('quota.gt', 'Greater than today'),
    },
]

export {
    SkipLogicOperators,
    getQuotaOptions,
}
